import type { Outfit } from "@mathbee/engine/shop";
import { createContext } from "react";

/** The active child's outfit: every Bee inside child mode wears it unless told otherwise (T5.9a). */
export const OutfitContext = createContext<Outfit>({});
